import decode from 'jwt-decode';

import StorageHandler from '../storage/StorageHandler';

import API from '../config/api';

const storageHandler = new StorageHandler();

const api = new API();

class NetworkHandler {

  async post(url, data) {
    return this.fetch(url, {
      method: 'POST',
      body: JSON.stringify(data),
    }).then((res) => res);
  }

  async put(url, data) {
    return this.fetch(url, {
      method: 'PUT',
      body: JSON.stringify(data),
    }).then((res) => res);
  }

  async delete(url, data) {
    return this.fetch(url, {
      method: 'DELETE',
      body: JSON.stringify(data),
    }).then((res) => res);
  }

  async fetch(url, options) {

    
    const headers = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
    };
		
	url = (url.slice(-1) == "/")?url.substr(0,(url.length - 1)):url;
	
    const res = await fetch(url, {
      headers,
      ...options,
    })
      .then(this.checkStatus)
      .then((response) => response.json())
      .then((json) => json)
      .catch((error) => error);
    return res;
  }

  loggedIn() {
    return (storageHandler.getID) ? true : false;
  }

  isTokenExpired(token) {
    try {
      const decoded = decode(token);
      if (decoded.exp < Date.now() / 1000) {
        
        return true;
      }
      return false;
    } catch (err) {
      return false;
    }
  }

  checkStatus(response) {
    
    if (response.status >= 200 && response.status < 300) {
      
      return response;
    }
    const error = new Error(response.statusText);
    error.response = response;
    throw error;
  }

  async requestCreateUser(data) {
    const url = `${api.API_URL_PATH + api.REGISTER}`;

    const response = await this.post(
      url,
      data
    );

    return response;
  }

  async requestUpdateUser(data) {
	  
    const url = `${api.API_URL_PATH + api.UPDATE_CRYODEX+"/update/"+data.Cryodex_ID}`;
    

    const response = await this.post(
      url,
      data
    );

    return response;
  }

  async requestDeleteInfodexGroupMember(data) {
   
    const url = `${api.API_URL_PATH + api.INFODEX_GROUP_MEMBER_DELETE + "/deleteInfodexFromGroup/"+storageHandler.getID()}`;
	
	//console.log(url);
    
    const response = await this.post( 
      url,
      data
    );
    return response;
  }

  async requestDeleteCryodexGroupMember(data) {
    const url = `${api.API_URL_PATH + api.CRYODEX_GROUP_MEMBER_DELETE + storageHandler.getID()}`;
    
    const response = await this.put(
      url,
      data
    );
    return response;
  }

  async requestGetUser(data) {

    const url = `${api.API_URL_PATH + api.LOGIN}`;
    
    const response = await this.post(
      url,
      data
    );
	
    return response;

  }

  async requestInfodexGroupsGet() {
    
    const url = `${api.API_URL_PATH + api.INFODEX_GROUPS_GET + storageHandler.getID()}`;
	
	

    const response = await this.fetch(
      url,
      null
    );

    return response;
  }

  async requestInfodexGroupsCreate(data) {
    const url = `${api.API_URL_PATH + api.INFODEX_GROUPS_POST}`;

    const response = await this.post(
      url,
      data
    );

    return response;
  }

  async requestCrydexGroupsGet() {
    const url = `${api.API_URL_PATH + api.CRYODEX_GROUPS_GET + storageHandler.getID()}`;
   
    const response = await this.fetch(
      url,
      null
    );
    return response;
  }

  async requestDeleteCryodexGroup(data) {
    const url = `${api.API_URL_PATH + api.CRYODEX_GROUP + data.Id}`;

    const response = await this.delete(
      url,
      data
    );

    return response;
  }

  async requestRenameCryodexGroup(data) {
    const url = `${api.API_URL_PATH + api.CRYODEX_GROUP_RENAME + data.Id}`;

    const response = await this.post(
      url,
      data
    );

    return response;
  }

  async requestCryodexGroupsCreate(data) {
    const url = `${api.API_URL_PATH + api.CRYODEX_GROUPS_POST}`;

    const response = await this.post(
      url,
      data
    );

    return response;
  }

  async requestGetCurrentUserInfomation() {
    const url = `${api.API_URL_PATH + api.GET_USER_INFORMATION + storageHandler.getID()}`;

    const response = await this.fetch(
      url,
      null
    );
    return response;
  }

  async requestGetUserProfileInfomation(data) {
    const url = `${api.API_URL_PATH + api.GET_USER_INFORMATION + data}`;

    const response = await this.fetch(
      url,
      null
    );
    return response;
  }

  async requestGetAllCountries() {
    const url = `${api.API_URL_PATH + api.GET_ALL_COUNTRIES}`;

    const response = await this.fetch(
      url,
      null
    );

    return response;
  }

  async requestGetAllCities() {
    const url = `${api.API_URL_PATH + api.GET_ALL_CITIES}`;

    const response = await this.fetch(
      url,
      null
    );

    return response;
  }

  async requestGetAllInfodexes() {
    const url = `${api.API_URL_PATH + api.INFODEX_ALL_GET }`;

    const response = await this.fetch(
      url,
      null
    );

    return response;
  }

  async requestGetLinkedInfodex(data) {

    const url = `${api.API_URL_PATH + api.INFODEX_LINKED_GET + storageHandler.getID()}`;

    const response = await this.fetch(
      url,
      null
    );
    return response;
  }

  async requestGetFavouredInfodexInfo(data) {
    
    var info = {
      CryodexId: storageHandler.getID()
    };

    const url = `${api.API_URL_PATH + api.INFODEX_LINKED_INFO_GET + data}`;
   
    const response = await this.put( 
      url,
      info
    );
    return response;

  }

  async requestGetLinkedInfodexInfo(data) {
    
    var info = {
      CryodexId: storageHandler.getID()
    };

    const url = `${api.API_URL_PATH + api.INFODEX_LINKED_INFO_GET + data}`;
   
    const response = await this.put( 
      url,
      info
    );
    
    return response;
  }

  async requestCryodexInfodexUnlink(data) {

    data.CryodexId = storageHandler.getID();
    const url = `${api.API_URL_PATH + api.INFODEX_LINKED_POST}`;

    const response = await this.post(
      url,
      data
    );
    return response;
  }

  async requestGetAllCryodexes() {
    
    const url = `${api.API_URL_PATH + api.CRYODEX_ALL_GET + storageHandler.getID()}`;
    
    const response = await this.fetch(
      url,
      null
    );

    return response;
  }

  async requestGetCryodexLinks() {
    const url = `${api.API_URL_PATH + api.CRYODEX_FEEDS_GET + "/" + storageHandler.getID() + "/" + storageHandler.getID()}`;

    const response = await this.fetch(
      url,
      null
    );

    return response;
  }

  async requestGetInfodex(data) {

    const Cryodex_ID = storageHandler.getID();
    const url = `${api.API_URL_PATH + api.INFODEX_GET + data + '/' + Cryodex_ID}`;

    const response = await this.fetch(
      url,
      null
    );

    return response;
  }

  async requestMapInfodexRelationship(data) {
    const url = `${api.API_URL_PATH + api.INFODEX_MAP_RELATIONSHIP_POST}`;
   
    data.Cryodex_ID = storageHandler.getID();

    const response = await this.post(
      url,
      data
    );

    return response;
  }

  async requestDeleteInfodexGroup(data) {
    const url = `${api.API_URL_PATH + api.INFODEX_GROUP + data.Id}`;

    const response = await this.delete(
      url,
      data
    );

    return response;
  }

  async requestRenameInfodexGroup(data) {
    const url = `${api.API_URL_PATH + api.INFODEX_GROUP_RENAME + data.Id}`;

    const response = await this.post(
      url,
      data
    );

    return response;
  }

  async requestMapCryodexRelationship(data) {
    const url = `${api.API_URL_PATH + api.CRYODEX_MAP_RELATIONSHIP_POST}`;
	//console.log(url);
//	console.log(data);
    const response = await this.post(
      url,
      data
    );
	//console.log(response);
    return response;
  }

  async requestCryodexInfodexLink(data) {
    const url = `${api.API_URL_PATH + api.CRYODEX_INFODEX_LINK_POST}`;

    const response = await this.post(
      url,
      data
    );

    return response;
  }

  async requestInviteCryodex(data) {

    const url = `${api.API_URL_PATH + api.CRYODEX_INVITE_GET + data.from + '/' + data.to + '/' + data.status}`;

    const response = await this.fetch(
      url,
      null
    );

    return response;

  }

  async requestSendLocation(data) {

    const url = `${api.API_URL_PATH + api.CRYODEX_LOCATION_GET + storageHandler.getID()	+ '/' + data.longitude + '/' + data.latitude + '/' + data.location_id + '/' + data.destLat + '/' + data.destLong + '/' + data.range}`;
   
    const response = await this.fetch(
      url,
      null
    )

    return response;

  }

  async requestCryodexPasswordReset(data) {
  
    const url = `${api.API_URL_PATH + api.CRYODEX_PASSWORD_RESET_POST}`;
   
    const response = await this.post(
      url,
      data
    );

    return response;
  }

  async requestIsolatedCryodex(data) {

    const url = `${api.API_URL_PATH + api.GET_USER_INFORMATION + data + '/' + storageHandler.getID()}`;

    const response = await this.fetch(
      url,
      null
    );
    return response;
  }

  async requestEditCryodex(data) {
  
    const url = `${api.API_URL_PATH + api.GET_USER_INFORMATION + data}`;
   
    const response = await this.fetch(
      url,
      null
    );
    return response;

  }

  async requestGetMailbox(data) {
 
    const url = `${api.API_URL_PATH + api.MAILBOX_GET + data + ''}`;

    const response = await this.fetch(
      url,
      null
    );

    return response;
  }

  async requestUpdateMailboxInvite(data) {
   
    const url = `${api.API_URL_PATH + api.MAILBOX_UPDATE_INVITE + ''}`;

    const response = await this.post(
      url,
      data
    );

    return response;
  }

  async requestCryodexTokenUpdate(data) {
    data.userId = storageHandler.getID();
    const url = `${api.API_URL_PATH + api.NOTIFICATION}`;

    const response = await this.post(
      url,
      data
    );

    return response;
  }

  async requestGetSettings(data) {
   
    const url = `${api.API_URL_PATH + api.SETTINGS_GET + data + ''}`;

    const response = await this.fetch(
      url,
      null
    );

    return response;
  }

  async requestSaveSettings(data) {
    
    const url = `${api.API_URL_PATH + api.SETTINGS_SAVE + ''}`;

    const response = await this.post(
      url,
      data
    );

    return response;
  }
 
  async getFriends(data) {
    
    const url = `${api.API_URL_PATH + api.GET_FRIENDS + '/' + data.payload}`;

    const response = await this.fetch(
      url,
      data
    );

    return response;
  }
  
  async getAllFriends(payload){
	  
	const url = `${api.API_URL_PATH + api.GET_ALL_FRIENDS + '/' + payload}`;
	
	const resp = await this.fetch(url,payload);
	
	return resp;
  }
  
   async getFs(action){
	  
	const url = `${api.API_URL_PATH + api.GET_FS+"/"+action.payload}`;
	
	const resp = await this.fetch(url,null);
	
	return resp;
  }
  
     async getF(action){
	  
	const url = `${api.API_URL_PATH + api.GET_F + "/" + action.payload}`;
	
	const resp = await this.fetch(url,null);
	
	return resp;
  }
  
  async getPlaces(action)
  {
	  //
	const url = `${api.API_URL_PATH + api.GET_PLACES + "/" + action.payload}`;
	
	//console.log(url);
	
	const resp = await this.fetch(url,null);
	
	return resp;
  }
  
  async requestGetRealFriendsGoingToMyLocation(action)
  {
	  const url = `${api.API_URL_PATH + api.GET_ALL_FRIENDS_GOING_TO_MY_LOCATION + "/" + action.payload}`;

	  const resp = await this.fetch(url,null);
	
	  return resp;
  }
}

export default NetworkHandler;